import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `
    <main class="flex min-h-[100dvh] min-h-screen w-full flex-col">
      <router-outlet />
    </main>
  `,
  styles: [],
})
export class AppComponent {}
